import React from "react";
import { triggerStyles } from "../styles";

const LinkButton = (props) => (
    <span className={ props.className }
          style={ Object.assign({}, triggerStyles(props.isActive), props.style) }
          onClick={ props.onClick }>{ props.children }</span>
);
LinkButton.propTypes = {
    className: React.PropTypes.string,
    isActive: React.PropTypes.bool,
    onClick: React.PropTypes.func,
    style: React.PropTypes.object
};
LinkButton.defaultProps = {
    isActive: false
};

export default LinkButton;


/** WEBPACK FOOTER **
 ** ./src/main/javascript/common/components/LinkButton.js
 **/